<script lang="ts" setup>
const props = defineProps<{
  label: string;
  modelValue: string;
  required?: boolean;
  placeholder?: string;
  rows?: number;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();

const textareaRows = props.rows || 4;
</script>

<template>
  <div class="mb-4">
    <label class="block font-medium text-brand-dark mb-2">
      {{ label }}
      <span v-if="required" class="text-dark">*</span>
    </label>
    <textarea
      :value="modelValue"
      :placeholder="placeholder"
      :required="required"
      :rows="textareaRows"
      class="w-full px-4 py-3 border border-secondary bg-white/66 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent resize-none"
      @input="emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
    />
  </div>
</template>
